import {
  GET_ANSWER_FROM_QUERY,
  GET_ANSWER_FROM_QUERY_SUCCESS,
  GET_ANSWER_FROM_QUERY_ERROR,
} from "./actionTypes"

export const getAnswerFromQuery = (payload) => {
  return {
    type: GET_ANSWER_FROM_QUERY,
    payload: payload
  }
}

export const getAnswerFromQuerySuccess = (summary) => ({
  type: GET_ANSWER_FROM_QUERY_SUCCESS,
  payload: summary
})

export const getAnswerFromQueryError = (error) => ({
  type: GET_ANSWER_FROM_QUERY_ERROR,
  payload: error
})
